// extracted by mini-css-extract-plugin
export var button = "_dr-0";
export var icon = "_dr-1";